import { render, staticRenderFns } from "./BodySettings.vue?vue&type=template&id=9f8214fc&scoped=true&"
import script from "./BodySettings.vue?vue&type=script&lang=js&"
export * from "./BodySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8214fc",
  null
  
)

export default component.exports